.DelayedLoader {
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	opacity: 0;
	animation: DelayedLoader-fadeIn 3s forwards;
}

@keyframes DelayedLoader-fadeIn {
	to {
		opacity: 1;
	}
}
